export type ClassValue =
  | string
  | number
  | null
  | undefined
  | false
  | ClassValue[]
  | { [key: string]: boolean | null | undefined };

export function cn(...inputs: ClassValue[]): string {
  const out: string[] = [];
  const push = (input: ClassValue) => {
    if (!input && input !== 0) return;
    if (typeof input === 'string' || typeof input === 'number') {
      out.push(String(input));
      return;
    }
    if (Array.isArray(input)) {
      input.forEach(push);
      return;
    }
    if (typeof input === 'object') {
      for (const [key, value] of Object.entries(input)) {
        if (value) out.push(key);
      }
    }
  };
  inputs.forEach(push);
  return out.join(' ');
}
